<modal-pds3 [isOpen]="true" (userRequest)="handleUserRequest($event)" srLabelledBy="wk-bulkchange__header-title">
    <vertical-layout-pds3 flowClass="wk-bulkchange-container">
        <vertical-layout-header-pds3 flowClass="wk-bulkchange__header">
            <h1 id="wk-bulkchange__header-title" class="wk-bulkchange__header-title">{{ "BulkChange.BulkChange" | translate }}</h1>
            <div class="wk-bulkchange__header-actions">
                <button-field-pds3 type="icon" size="large" class="wk-bulkchange__header-close">
                    <button (click)="close()" type="button">
                        <icon-pds3 name="wk-icon-close" />
                        <sr-only-pds3>{{ "General.CloseModal" | translate }}</sr-only-pds3>
                    </button>
                </button-field-pds3>
            </div>
        </vertical-layout-header-pds3>
        @if (isMultipleJobTypesSelected) {
            <vertical-layout-content-pds3 flowClass="wk-bulkchange__content">
                <div [attr.class]="'notification-error'">
                    <notification-pds3 type="error">
                        <div *notificationHeadingPds3>{{ "JobsAndBilling.Errors.MultipleJobTypeSelectionLabel" | translate }}</div>
                        <span *notificationContentPds3>
                            <span>{{ "JobsAndBilling.Errors.MultipleJobTypeSelectionContent" | translate }}</span>
                        </span>
                    </notification-pds3>
                </div>
            </vertical-layout-content-pds3>
        }
        @if (invalidTargetStartDate) {
            <vertical-layout-content-pds3 flowClass="wk-bulkchange__content">
                <div [attr.class]="'notification-error'">
                    <notification-pds3 type="error">
                        <div *notificationHeadingPds3>{{ "JobsAndBilling.Errors.InvalidTargetStartDateLabel" | translate }}</div>
                        <span *notificationContentPds3>
                            <span>{{ "JobsAndBilling.Errors.InvalidTargetStartDateContent" | translate }}</span>
                        </span>
                    </notification-pds3>
                </div>
            </vertical-layout-content-pds3>
        }
        @if (invalidTargetEndDate) {
            <vertical-layout-content-pds3 flowClass="wk-bulkchange__content">
                <div [attr.class]="'notification-error'">
                    <notification-pds3 type="error">
                        <div *notificationHeadingPds3>{{ "JobsAndBilling.Errors.InvalidTargetEndDateLabel" | translate }}</div>
                        <span *notificationContentPds3>
                            <span>{{ "JobsAndBilling.Errors.InvalidTargetEndDateContent" | translate }}</span>
                        </span>
                    </notification-pds3>
                </div>
            </vertical-layout-content-pds3>
        }
        <vertical-layout-content-pds3 flowClass="wk-bulkchange-content">
            <div class="wk-bulkchange__field">
                <label class="wk-bulkchange__field-label">{{ "BulkChange.Update" | translate }}</label>
                <div class="wk-bulkchange__field-inputs">
                    <div class="wk-bulkchange__field-input">
                        <kendo-dropdownlist-wrapper
                            name="returnField"
                            [data]="groupedReturnFieldOptions"
                            [value]="selectedReturnField"
                            (change)="handleFieldSelectionChange($event)"
                            [disabled]="isUpdating || isDone"
                            [valuePrimitive]="false"
                            [isGroupingEnabled]="true"
                            valueField="value"
                            textField="label"
                        />
                    </div>
                    <div class="wk-bulkchange__field-text">{{ "BulkChange.ChangeTo" | translate }}</div>
                    <div class="wk-bulkchange__field-input">
                        @if (selectedReturnField.value === "TargetStartDate" || selectedReturnField.value === "TargetEndDate") {
                            <kendo-datepicker
                                #dp
                                name="value"
                                format="yyyy-MM-dd"
                                placeholder="{{ currentLanguage == 'en-CA' ? 'YYYY-MM-DD' : 'AAAA-MM-JJ' }}"
                                (keydown)="handleKeyDown($event)"
                                (valueChange)="handleValueChange($event, selectedReturnField.value)"
                                [disabled]="!selectedReturnField || isUpdating || isDone"
                            >
                                <kendo-datepicker-messages
                                    today="{{ 'Code.Today' | translate }}"
                                    toggle="{{ 'BulkChange.ToggleCalendar' | translate }}"
                                ></kendo-datepicker-messages>
                            </kendo-datepicker>
                        } @else {
                            <kendo-dropdownlist-wrapper
                                name="returnField"
                                [data]="selectedReturnFieldOptions"
                                [value]="selectedValue"
                                (change)="handleValueSelectionChange($event)"
                                [disabled]="!selectedReturnField || isUpdating || isDone"
                                [valuePrimitive]="false"
                                valueField="value"
                                textField="label"
                            />
                        }
                    </div>
                </div>
            </div>
        </vertical-layout-content-pds3>
        <vertical-layout-footer-pds3 flowClass="wk-bulkchange__footer">
            @if (isUpdating || isDone || completedUpdateCounter > 0) {
                <div class="wk-bulkchange__footer-text">
                    <span>{{ completedUpdateCounter }}</span>
                    @if (isJobsBillingDashboard) {
                        @if (completedUpdateCounter > 1) {
                            <span>{{ "JobsAndBilling.Declarations.jobUpdatedDeclarations" | translate }}</span>
                        } @else {
                            <span>{{ "JobsAndBilling.Declarations.jobUpdatedDeclaration" | translate }}</span>
                        }
                    } @else {
                        @if (completedUpdateCounter > 1) {
                            <span>{{ "BulkChange.UpdatedDeclarations" | translate }}</span>
                        } @else {
                            <span>{{ "BulkChange.UpdatedDeclaration" | translate }}</span>
                        }
                    }
                </div>
            } @else {
                <div class="wk-bulkchange__footer-text">
                    <span>{{ affectedDeclarations }}</span>
                    @if (isJobsBillingDashboard) {
                        @if (affectedDeclarations > 1) {
                            <span>{{ "JobsAndBilling.Declarations.jobAffectedDeclarations" | translate }}</span>
                        } @else {
                            <span>{{ "JobsAndBilling.Declarations.jobAffectedDeclaration" | translate }}</span>
                        }
                    } @else {
                        @if (affectedDeclarations > 1) {
                            <span>{{ "BulkChange.AffectedDeclarations" | translate }}</span>
                        } @else {
                            <span>{{ "BulkChange.AffectedDeclaration" | translate }}</span>
                        }
                    }
                </div>
            }
            <div class="wk-bulkchange__footer-actions">
                @if (!isDone) {
                    <button-field-pds3 type="primary" size="large">
                        <button
                            type="submit"
                            [disabled]="!selectedReturnField.value || selectedValue.value === undefined || !affectedDeclarations || isUpdating"
                            (click)="applyChanges()"
                        >
                            @if (isUpdating) {
                                <app-loader [isOverlay]="false" size="button" />
                            }
                            {{ "General.Apply" | translate }}
                        </button>
                    </button-field-pds3>
                    <button-field-pds3 type="text" size="large">
                        <button type="button" [disabled]="isUpdating" (click)="close()">{{ "General.Cancel" | translate }}</button>
                    </button-field-pds3>
                } @else {
                    <button-field-pds3 type="text" size="large">
                        <button type="button" (click)="close()">{{ "General.Close" | translate }}</button>
                    </button-field-pds3>
                }
            </div>
        </vertical-layout-footer-pds3>
    </vertical-layout-pds3>
</modal-pds3>
